import makeStyles from '@mui/styles/makeStyles';

import { Theme } from '../../types';

const loaderStyles = makeStyles((theme: Theme) => ({
    relativeHeight100: {
        position: 'relative',
        height: '100%',
        minHeight: 'inherit'
    },
    absoluteHeight100: {
        position: 'absolute',
        height: '100%',
        minHeight: 'inherit'
    },
    wrapLoader: {
        height: '100%',
        width: '100%',
        position: 'absolute',
        zIndex: 200,
        //backgroundColor: theme.palette.grey.fade50,
        borderRadius: '6px'
    },
    wrapLoaderRelativePosition: {
        height: '100%',
        width: '100%',
        position: 'relative',
        zIndex: 200,
        //backgroundColor: theme.palette.grey.fade50,
        borderRadius: '6px'
    },
    loaderBox: {
        width: 'fit-content',
        padding: '20px',
        backgroundColor: theme.palette.primary.lighten90,
        borderRadius: '6px'
    },
    height100: {
        height: '100%'
    }
}));

export default loaderStyles;
